import moment from "moment";
import * as SpeechSDK from "microsoft-cognitiveservices-speech-sdk";

export const speakWithAzure = (
  text,
  voiceName,
  azureKey,
  azureRegion,
  onEnd,
  onError,
  onStart,
) => {
  const speechConfig = SpeechSDK.SpeechConfig.fromSubscription(
    azureKey,
    azureRegion,
  );
  speechConfig.speechSynthesisVoiceName = voiceName;

  const audioConfig = SpeechSDK.AudioConfig.fromDefaultSpeakerOutput();
  onStart?.(); // Start callback
  const synthesizer = new SpeechSDK.SpeechSynthesizer(
    speechConfig,
    audioConfig,
  );

  synthesizer.speakTextAsync(
    text,
    (result) => {
      // if (result.reason === SpeechSDK.ResultReason.SynthesizingAudioCompleted) {
      //   synthesizer.close();
      //   onEnd?.(); // Only after finish
      // } else {
      //   synthesizer.close();
      //   onError?.(result.errorDetails);
      // }
    },
    (err) => {
      synthesizer.close();
      onError?.(err);
    },
  );
  onEnd?.();

  return synthesizer;
};

/** Turn stored follow-ups into string[] for chips (handles list, { questions: [] }, object items). */
export const normalizeFollowupOptions = (meta) => {
  if (!meta || typeof meta !== "object") return [];
  const raw = meta.followup ?? meta.follow_up ?? meta.suggested_questions;
  if (raw == null) return [];
  if (Array.isArray(raw)) {
    return raw
      .map((item) => {
        if (typeof item === "string") return item.trim();
        if (item && typeof item === "object") {
          return String(
            item.text ?? item.question ?? item.label ?? item.content ?? "",
          ).trim();
        }
        return "";
      })
      .filter(Boolean);
  }
  if (typeof raw === "object" && Array.isArray(raw.questions)) {
    return raw.questions
      .filter((q) => typeof q === "string" && q.trim())
      .map((q) => q.trim());
  }
  return [];
};

export const convertToMessageFormat = (array) => {
  return array.flatMap((obj) => {
    const chart =
      obj?.assistant_chart || obj?.ai_metadata?.chart_response || {};

    const imgPath =
      (
        obj?.imgPath ||
        chart?.base64_image ||
        chart?.base64image ||
        ""
      ).trim?.() || "";

    const chartIntent =
      obj?.chartIntent === true ||
      chart?.chart_intent === true ||
      chart?.chart_intent === true ||
      !!imgPath;

    return [
      {
        text: obj?.human || obj?.human_text || "",
        sender: "user",
        chatId: obj?.chat_id,
        userSessionId: obj?.user_session_id || obj?.session_id,
        feedback: obj?.feedback,
        time: obj?.timestamp_created || obj?.created_at,
        options: normalizeFollowupOptions(obj?.ai_metadata),
        email: obj?.ai_metadata?.email,
        withoutMarkDown: obj?.ai_metadata?.ai_wo_markdown,
        chartIntent: false,
        imgPath: "",
        tableFound: obj?.ai_metadata?.table_found_in_response?.table_found_flag,
        blobName: obj?.ai_metadata?.table_found_in_response?.blob_name,
        agentType: obj?.ai_metadata?.agent_type,
        sources: obj?.sources || obj?.ai_metadata?.sources || [],
      },
      {
        text: obj?.ai || obj?.assistant_text || "",
        sender: "bot",
        chatId: obj?.chat_id,
        userSessionId: obj?.user_session_id || obj?.session_id,
        feedback: obj?.feedback,
        time: obj?.timestamp_created || obj?.created_at,
        options: normalizeFollowupOptions(obj?.ai_metadata),
        email: obj?.ai_metadata?.email,
        withoutMarkDown: obj?.ai_metadata?.ai_wo_markdown,
        chartIntent,
        imgPath,
        tableFound: obj?.ai_metadata?.table_found_in_response?.table_found_flag,
        blobName: obj?.ai_metadata?.table_found_in_response?.blob_name,
        agentType: obj?.ai_metadata?.agent_type,
        sources: obj?.sources || obj?.ai_metadata?.sources || [],
      },
    ];
  });
};

export const getCurrentDateTime = () => {
  const now = moment();

  // Construct the desired ISO 8601 format with microseconds
  const isoString = now.toISOString().replace("Z", ""); // Remove 'Z' to add manually later
  return `${isoString.slice(0, -1)}Z`;
};
